import { post } from '@/requests/request'


export const sendComment = async ({ to = 'vireo@affordancestudio.com', subject, body, from = 'vireo@affordancestudio.com' }) => {
	return await post('sendCommentEmail', { to, subject: [ subject ], body: [ body ], from })
}